export const BUSINESS_INCOME_SOURCE = {
    primary: {
        en: 'Primary Source',
        es: 'Fuente principal'
    },
    significant: {
        en: 'Significant Source',
        es: 'Fuente significativa'
    },
    supl: {
        en: 'Supplemental Source',
        es: 'Fuente suplementaria'
    },
    noop: {
        en: 'My business was not operating at the time',
        es: 'Mi negocio no estaba operando en ese momento'
    },
    other: {
        en: 'Other',
        es: 'Otro'
    },
    idk: {
        en: "Don't Know",
        es: 'No sé'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
